import type * as Types from '~/gql/graphql';

import { gql } from 'urql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PrepareTaskAttachmentForUploadMutationVariables = Types.Exact<{
  input: Types.PrepareTaskAttachmentForUploadInput;
}>;


export type PrepareTaskAttachmentForUploadMutation = { prepareTaskAttachmentForUpload?: { __typename: 'PrepareTaskAttachmentForUploadErrors', errors: Array<{ __typename: 'InputValidationError' } | { __typename: 'TaskAccessDenied' } | { __typename: 'TaskDoesNotExist' }> } | { __typename: 'PrepareTaskAttachmentForUploadSuccess', key: string, url: string } | null };


export const PrepareTaskAttachmentForUploadDocument = gql`
    mutation prepareTaskAttachmentForUpload($input: PrepareTaskAttachmentForUploadInput!) {
  prepareTaskAttachmentForUpload(input: $input) {
    __typename
    ... on PrepareTaskAttachmentForUploadSuccess {
      key
      url
    }
    ... on PrepareTaskAttachmentForUploadErrors {
      errors {
        __typename
      }
    }
  }
}
    `;

export function usePrepareTaskAttachmentForUploadMutation() {
  return Urql.useMutation<PrepareTaskAttachmentForUploadMutation, PrepareTaskAttachmentForUploadMutationVariables>(PrepareTaskAttachmentForUploadDocument);
};